import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router,Route,Routes,Navigate,} from "react-router-dom";
import HomePage from './pages/homepage';
import SignUpPage from './pages/signup';
import FeedPage from './pages/feed';
import IdeasPage from './pages/ideas';
import BillingPage from './pages/billing';
import ScanPage from './pages/scan';
import LoginPage from './pages/login';
import PaymentPage from './pages/payment';
import SchedulePage from './pages/schedule';
import OnboardingPage from './pages/onboarding';
import CheckoutSuccessful from './pages/successful-checkout';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getAuthCode } from './functions/getAuthCode';
import ResetPassword from './pages/reset-password';
import ConfirmPassword from './pages/confirm-password';

const root = ReactDOM.createRoot(document.getElementById('root'));
let endpage;
let serverStatus;

const fetchDataAndLogResponse = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/verification", {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ auth_code: await getAuthCode() }),
    });

    const status = response.status;

    // Handle different statuses
    if (status === 200 || status === 206) {
      serverStatus = status; 
      const data = await response.text(); // Process successful response
      console.log("Success:", data);
      return data;
    } else if (status === 401) {
      endpage ='/signup'
      // Handle 401-specific logic, e.g., redirect to login
    } else if (status === 402) {
      endpage = '/payment';
      // Handle 402-specific logic, e.g., prompt for payment
    } else if (status === 500) {
      endpage = '/';
      // Handle 500-specific logic, e.g., retry or notify the user
    } else {
      console.error(`Unexpected status code: ${status}`);
      endpage = '/';
      // Handle any other unexpected status codes
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle fetch error (e.g., network issues)
  }
};

// Call the function to fetch and log the response
const auth = await fetchDataAndLogResponse();
console.log(auth);
let booleanValue = auth === "true";
const clientId = '229751320017-epf0d8cfvnb9nd2egpl13qrp7fblj1in.apps.googleusercontent.com';

root.render(
  <GoogleOAuthProvider clientId={clientId}>
  <Router>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup"  element={<SignUpPage />} />
      <Route path="/login"  element={<LoginPage />} />
      <Route path="/reset-password"  element={<ResetPassword />} />
      <Route path="/confirm-new-password"  element={<ConfirmPassword />} />
      <Route path="/feed" element={booleanValue ? (<FeedPage serverStatus={serverStatus} />) : (<Navigate replace to={endpage} />)} />
      <Route path="/onboarding" element={booleanValue ? (<OnboardingPage serverStatus={serverStatus} />) : (<Navigate replace to={endpage} />)} />
      <Route path="/payment" element={<PaymentPage />}/>
      <Route path="/checkout-complete" element={<CheckoutSuccessful />}/>
      <Route path="/ideas" element={booleanValue ? (<IdeasPage />) : (<Navigate replace to={endpage} />)} />
      <Route path="/sites" element={booleanValue ? (<ScanPage />) : (<Navigate replace to={endpage} />)} />
      <Route path="/schedule" element={booleanValue ? (<SchedulePage />) : (<Navigate replace to={endpage} />)} />
      <Route path="/settings" element={booleanValue ? (<BillingPage />) : (<Navigate replace to={endpage} />)} />
      <Route path="*" element={<div>404</div>} />
    </Routes>
  </Router>
  </GoogleOAuthProvider>
);